export const INPUT_TEXTAREA_DISPLAY_NAME = "InputTextArea";
